export const tenantMap = {
  BSO: 'bayerische-staatsoper',
  juliaFisher: 'Julia Fischer',
  staatsoperTV: 'staatsoperTV',
  perceNeige: 'perce-neige',
  zurichOperahaus: 'zurich-operahaus',
};
